<template>
  <div class="space-y-6">
    <!-- Breadcrumb -->
    <nav v-if="breadcrumb" class="flex justify-between items-center border-b border-gray-200 pb-3">
      <div>
        <div class="hidden md:flex text-sm text-gray-600 items-center space-x-2">
          <router-link :to="{ name: 'home' }" class="hover:text-teal-600">Home</router-link>
          <span>/</span>
          <router-link :to="{ name: 'groups' }" class="hover:text-teal-600">Groups</router-link>
        </div>
        <h2 class="text-2xl font-semibold text-gray-800 mt-1">Customer Groups</h2>
      </div>
      <button
        v-if="$store.getters.can('create_groups')"
        @click="showModals({ modal: 'groups' })"
        class="bg-teal-600 text-white hover:bg-teal-700 px-4 py-2 rounded-md shadow-sm transition-all duration-150"
      >
        + New Group
      </button>
    </nav>

    <!-- Main Card -->
    <div class="bg-white rounded-lg shadow p-4 border border-gray-200">
      <div class="flex flex-col md:flex-row md:justify-between md:items-end mb-4 gap-4">
        <!-- Records -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Records per page</label>
          <select
            v-model="recordsPerPage"
            class="bg-white border border-gray-300 text-sm rounded-md px-3 py-2 focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
          >
            <option v-for="num in [5,10,25,50,100,250]" :key="num">{{ num }}</option>
          </select>
        </div>

        <!-- Search -->
        <div class="flex-1 md:max-w-xs">
          <label class="block text-sm font-medium text-gray-700 mb-1">Search</label>
          <input
            v-model="searchString"
            @change="loadStats(currentPage)"
            type="text"
            placeholder="Search by name..."
            class="w-full border border-gray-300 text-sm rounded-md px-3 py-2 focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
          />
        </div>
      </div>

      <!-- Table -->
      <div class="overflow-x-auto">
        <table v-if="!loading" class="min-w-full text-sm text-left border-collapse">
          <thead>
            <tr class="bg-gray-100 text-gray-700 font-semibold">
              <th class="px-4 py-2">#</th>
              <th class="px-4 py-2">Name</th>
              <th class="px-4 py-2">Customers</th>
              <th class="px-4 py-2">Owner</th>
              <th class="px-4 py-2">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(record, index) in records"
              :key="record.id"
              class="border-t hover:bg-gray-50 even:bg-gray-50"
            >
              <td class="px-4 py-2 font-medium text-gray-700">{{ offset + index + 1 }}</td>
              <td class="px-4 py-2 text-teal-600 font-medium">
                <router-link :to="{ name: 'group', params: { id: record.id } }" class="hover:underline">
                  {{ record.name }}
                </router-link>
              </td>
              <td class="px-4 py-2 text-gray-600">{{ record.customersCount }}</td>
              <td class="px-4 py-2 text-gray-600">{{ record.createdBy.first_name }} {{ record.createdBy.last_name }}</td>
              <td class="px-4 py-2 text-gray-500">{{ record.description }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Loading -->
        <div v-else class="py-10 text-center text-gray-600">
          <feather animation="spin" type="loader" size="32" class="mx-auto mb-2" />
          <p>Loading customer groups...</p>
        </div>
      </div>

      <!-- Pagination -->
      <Pagination
        class="mt-4"
        :total-count="recordsCount"
        :current-page="currentPage"
        :tag="'Groups'"
        :offset="offset"
        :records-count="records != null ? records.length || 0 : 0"
        :click-handler="loadStats"
        :records-per-page="parseInt(recordsPerPage)"
      />
    </div>
  </div>
</template>


<script>
import moment from "moment";
import GraphQl from "../../../services/graphql.service";
import Pagination from "@/components/Pagination";

export default {
  name: "CustomerGroups",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: 10,
      recordsCount: 0,
      records: [],
      orgId: this.$store.getters.orgId,
      currentPage: 1,
      loading: true
    }
  },
  props: { 
    title: {type: String, default: 'Customer Groups'},
    rowsPerPage: {type: Number, default: 10},
    breadcrumb: {default: true, type: Boolean}
  },
  mounted() {
    this.$root.$on("refresh", (data) => {
      if (data === 'groups') this.loadStats()
    });
    this.loadStats();
  },
  watch: {
    recordsPerPage: function () {
      this.loadStats(this.currentPage)
    },
    searchString: function () {
      this.currentPage = 1;
    }
  },
  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  methods: {
    showModals(data) {
      this.$root.$emit("show_modal", data);
    },

    formatDate(timestamp, format) {
      return moment(timestamp).format(format);
    },

    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      // let params = 'limit: ' + this.recordsPerPage + ', ' +
      //     'offset: ' + this.offset + ', ' +
      //     'order: "created_at desc", ' +
      //     'search: "' + this.searchString + '"';
      
          const query = `
{
  customerGroupsCount(search: "${this.searchString}")
  customerGroups(
    limit: ${this.recordsPerPage},
    offset: ${this.offset},
    order: "created_at desc",
    search: "${this.searchString}"
  ) {
    id
    name
    description
    customersCount
    createdBy { first_name last_name id }
  }
}`;
GraphQl.sendRequest(query)
  .then(res => {
    this.records = res.customerGroups;
    this.recordsCount = res.customerGroupsCount;
  })
  .finally(() => {
    this.loading = false;
  });

    }
  }
}
</script>

<style scoped>
</style>